import React from "react";
import "./SuccessStories.css";
import Navbar from "../components/NavBar";
import SEO from "../components/SEO";


const statsData = [
    { value: "95%", label: "Client Satisfaction Rate" },
    { value: "50K +", label: "Professionals Trained" },
    { value: "35%", label: "Performance Improvement" },
    { value: "3", label: "Countries Served" },
];

const storiesData = [
    {
        id: 3,
        title: "Raghuram Burra",
        role: "Vice President & Delivery Head, TAO Digital",
        desc: "Bringing together senior leaders from across TAO India for the Mastering Customer Experience through Leadership Excellence leadership training program was an experience in itself—one that reminded me just how powerful learning can be when done together.",
    },
    {
        id: 1,
        title: "Sangeet Nyapati",
        role: "Country HR Manager - D&B",
        desc: "As an HR leader, I value partners who bring reliability, ownership, and genuine partnership — RTS TechSol has consistently demonstrated all of these. It’s been a strong collaboration, and we look forward to building more future-focused learning experiences together.  Sangeet Srinivas Nyapati, Director and Country Head - People, Dun & Bradstreet Technology Corporate Services.",
    },
    {
        id: 2,
        title: "Tulasi Pochampalli",
        role: "VP-HR ME & APAC, Envoy Global",
        desc: "Thank you for delivering an outstanding training program for our new managers. The team’s thoughtful approach transformed an initial concept into a comprehensive experience that addressed every essential aspect of leadership for those at the beginning of their journey. We are already witnessing significant growth among our emerging leaders.",
    },
   

];

const caseStudiesData = [
    {
        id: 1,
        title: "Digital Transformation",
        description: "Helped a Fortune 500 company transition 5,000+ employees to cloud-based technologies.",
        highlight: "40% productivity increase"
    },
    {
        id: 2,
        title: "Leadership Excellence",
        description: "Developed next-generation leaders across global operations.",
        highlight: "95% retention rate"
    },
    {
        id: 3,
        title: "Agile Transformation",
        description: "Implemented agile methodologies across 20 teams.",
        highlight: "60% faster delivery"
    }
];

const SuccessStories = () => {
    return (
        <section className="success-page">
            <SEO
                title="Success Stories"
                description="Read RTS Techsol success stories, client testimonials, and case studies showing real-world learning and transformation impact."
                path="/successStories"
            />
            <Navbar />

            {/* 1. Hero Section */}
            <div className="rts-hero-section">
                <div className="rts-hero-content">
                    <h1 className="hero-title">Our Success Stories</h1>
                    <p className="hero-tagline">
                        Real-world results and tangible business impact achieved through our strategic partnerships.
                    </p>
                    <a href="#stories-grid" className="hero-cta-btn">
                        View Case Studies
                    </a>
                </div>
            </div>

            {/* 2. Stats Section */}
            <div className="rts-stats-section">
                <div className="stats-container">
                    {statsData.map((stat, index) => (
                        <div key={index} className="statt-card">
                            <p className="statt-value">{stat.value}</p>
                            <p className="statt-label">{stat.label}</p>
                        </div>
                    ))}
                </div>
            </div>

            {/* 3. Success Stories Grid */}
            <div className="container">
                <div className="success-header">
                    <h2 className="stories-main-heading">Testimonials</h2>
                    <p>Discover how we help organizations Rise to Scale.</p>
                </div>

                <div className="stories-grid" id="stories-grid">
                    {storiesData.map((story) => (
                        <div key={story.id} className="story-card">
                            <div className="story-body">

                                <p className="story-desc">{story.desc}</p>
                                <p className="story-title">{story.title}</p>
                                <p className="story-role">{story.role}</p>

                            </div>
                        </div>
                    ))}
                </div>
            </div>

            {/* 4 */}

            <div className="case-studies-section">
                <div className="container">
                    <h2 className="case-studies-heading">Featured Case Studies</h2>
                    <div className="case-studies-grid">
                        {caseStudiesData.map((study) => (
                            <div key={study.id} className="case-study-card">
                                <h3 className="case-study-title">{study.title}</h3>
                                <p className="case-study-description">{study.description}</p>
                                <p className="case-study-highlight">{study.highlight}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

        </section>
    );
};

export default SuccessStories;
